import { CoverageType } from '../shared/enum/coverage-type.enum';
import { VehicleTypes } from '../shared/enum/vehicle-type.enum';
import { VehicleStates } from '../shared/enum/vehicle-state.enum';
import { Address } from '../shared/models/interface/concretes/address.interface';
import { VehicleCategories } from '../shared/enum/vehicle-category.enum';

export type DeclarationState = {
  email: string;
  address: Address | null;
  effect_date: string | Date | null;

  chosenCoverageType: CoverageType | null;
  physicalPersons: PhysicalPersonState | null;
  vehicles: VehicleState | null;
};

// #region Physical Person
export const initialPhysicalPersonState: PhysicalPersonState = {
  persons: []
};

export interface PhysicalPersonState {
  persons: PersonInfo[];
}

export interface PersonInfo {
  id: string | null;
  firstName: string | null;
  lastName: string | null;
  birthDate: string | null;
  isSubscriber: boolean | null;
  isProtected: boolean | null;
}
// #endregion

// #region Vehicle
export const initialVehicleState: VehicleState = {
  vehicles: []
};

export interface VehicleState {
  vehicles: VehicleInfo[];
}

export interface VehicleInfo {
  id: string | null;
  vehicleType: VehicleTypes | null;
  vehicleState: VehicleStates | null;
  vehicleBrand: string | null;
  vehicleSerialNumber: string | null;
  purchaseValue: number | null;
  purchaseDate: string | null;
  firstRegistrationYear: number | null;
  isOwner: boolean | null;
  powerComplianceCertified: boolean | null;
  optionRc: boolean | null;
  optionRcOriginal: boolean | null;  // définit si l'option RC a été activée par l'utilisateur, ou est devenue incluse automatiquement
  optionAssistance1: boolean | null;
  optionAssistance2: boolean | null;
  vehicleCategory: VehicleCategories | null;
  drivers: PersonInfo[];
}
// #endregion

export const initialDeclarationState: DeclarationState = {
  email: '',
  address: null,
  effect_date: null,
  chosenCoverageType: null,
  physicalPersons: initialPhysicalPersonState,
  vehicles: initialVehicleState
};
